export default __webpack_public_path__ + "static/media/E-commerce-gif2.890a6263.gif";